export const mockStudyPosts = [
  // Web Security (8개)
  {
    id: 'study1',
    user_id: 'student1',
    type: 'study' as const,
    title: 'Burp Suite Intruder 모드 사용법 질문 - Payload 설정이 안돼요',
    content: 'Burp Suite Intruder를 사용해서 파라미터 값을 변경하며 테스트하려고 하는데 자꾸 에러가 나요. Payload 설정은 Numbers로 했고 1부터 100까지 테스트하려고 합니다. Position도 제대로 설정한 것 같은데 왜 안될까요? Community Edition 사용 중입니다.',
    tags: ['burp-suite', 'intruder', 'web', 'beginner'],
    status: 'open',
    likes_count: 23,
    replies_count: 5,
    views_count: 156,
    created_at: new Date(Date.now() - 1 * 3600000).toISOString(),
    profiles: {
      id: 'student1',
      username: 'newbie_hacker',
      display_name: 'Newbie Hacker',
      points: 340,
      reputation: 45
    }
  },
  {
    id: 'study2',
    user_id: 'student2',
    type: 'study' as const,
    title: 'SQL Injection Union 기반 공격 컬럼 개수 맞추기 질문',
    content: 'Union based SQL Injection을 공부하고 있는데 컬럼 개수를 맞춰야 한다는 게 무슨 의미인지 잘 모르겠어요. ORDER BY로 컬럼 개수를 찾는다고 하는데 왜 그렇게 하는 건가요? 실습할 수 있는 좋은 사이트도 추천 부탁드립니다.',
    tags: ['sql-injection', 'union', 'web', 'learning'],
    status: 'solved',
    likes_count: 45,
    replies_count: 8,
    views_count: 287,
    created_at: new Date(Date.now() - 4 * 3600000).toISOString(),
    profiles: {
      id: 'student2',
      username: 'sql_learner',
      display_name: 'SQL Learner',
      points: 520,
      reputation: 78
    }
  },
  {
    id: 'study3',
    user_id: 'student3',
    type: 'study' as const,
    title: 'XSS 취약점 찾기 - 필터링 우회 방법 알려주세요',
    content: '웹 사이트에서 XSS 취약점을 찾아보려고 하는데 막막합니다. input 태그에 &lt;script&gt;alert(1)&lt;/script&gt; 넣어봤는데 필터링되는 것 같아요. 우회 방법이나 체계적으로 테스트하는 방법을 알려주실 수 있나요?',
    tags: ['xss', 'web', 'filter-bypass', 'beginner'],
    status: 'open',
    likes_count: 34,
    replies_count: 6,
    views_count: 512,
    created_at: new Date(Date.now() - 10 * 3600000).toISOString(),
    profiles: {
      id: 'student3',
      username: 'web_newbie',
      display_name: 'Web Newbie',
      points: 280,
      reputation: 32
    }
  },
  {
    id: 'study4',
    user_id: 'student4',
    type: 'study' as const,
    title: 'CSRF 토큰 우회 가능한 경우가 있나요?',
    content: 'CSRF 공격을 공부하고 있는데 대부분의 사이트가 CSRF 토큰을 사용하더라고요. 토큰이 있어도 우회할 수 있는 방법이 있나요? SameSite 쿠키 속성도 함께 공부하고 싶습니다.',
    tags: ['csrf', 'web', 'token', 'security'],
    status: 'open',
    likes_count: 28,
    replies_count: 4,
    views_count: 234,
    created_at: new Date(Date.now() - 15 * 3600000).toISOString(),
    profiles: {
      id: 'student4',
      username: 'csrf_student',
      display_name: 'CSRF Student',
      points: 410,
      reputation: 56
    }
  },
  {
    id: 'study5',
    user_id: 'student5',
    type: 'study' as const,
    title: 'SSRF 취약점 실습 환경 추천해주세요',
    content: 'Server-Side Request Forgery 공격을 실습해보고 싶은데 안전한 실습 환경이 필요합니다. PortSwigger Web Security Academy 외에 다른 좋은 플랫폼 있을까요?',
    tags: ['ssrf', 'web', 'practice', 'lab'],
    status: 'solved',
    likes_count: 52,
    replies_count: 9,
    views_count: 389,
    created_at: new Date(Date.now() - 20 * 3600000).toISOString(),
    profiles: {
      id: 'student5',
      username: 'ssrf_learner',
      display_name: 'SSRF Learner',
      points: 630,
      reputation: 92
    }
  },
  {
    id: 'study6',
    user_id: 'student6',
    type: 'study' as const,
    title: 'JWT 토큰 디코딩하고 분석하는 방법',
    content: 'JWT 토큰을 받았는데 어떻게 분석해야 할지 모르겠어요. jwt.io에서 디코딩은 해봤는데 알고리즘 변조 공격은 어떻게 시도하나요? None 알고리즘 취약점도 궁금합니다.',
    tags: ['jwt', 'web', 'authentication', 'token'],
    status: 'open',
    likes_count: 41,
    replies_count: 7,
    views_count: 456,
    created_at: new Date(Date.now() - 25 * 3600000).toISOString(),
    profiles: {
      id: 'student6',
      username: 'jwt_student',
      display_name: 'JWT Student',
      points: 490,
      reputation: 67
    }
  },
  {
    id: 'study7',
    user_id: 'student7',
    type: 'study' as const,
    title: 'GraphQL API 테스트 시작하는 방법',
    content: 'REST API는 테스트해봤는데 GraphQL은 처음입니다. Introspection 쿼리로 스키마를 확인하는 방법과 기본적인 취약점 테스트 방법을 알려주세요.',
    tags: ['graphql', 'web', 'api', 'testing'],
    status: 'open',
    likes_count: 37,
    replies_count: 5,
    views_count: 298,
    created_at: new Date(Date.now() - 30 * 3600000).toISOString(),
    profiles: {
      id: 'student7',
      username: 'graphql_newbie',
      display_name: 'GraphQL Newbie',
      points: 360,
      reputation: 48
    }
  },
  {
    id: 'study8',
    user_id: 'student8',
    type: 'study' as const,
    title: 'File Upload 취약점 테스트 방법 질문',
    content: '파일 업로드 기능에서 취약점을 찾고 싶은데 어떤 파일들을 업로드해봐야 하나요? PHP 웹쉘 업로드는 시도해봤는데 확장자 필터링이 있는 것 같습니다.',
    tags: ['file-upload', 'web', 'webshell', 'bypass'],
    status: 'solved',
    likes_count: 48,
    replies_count: 10,
    views_count: 567,
    created_at: new Date(Date.now() - 35 * 3600000).toISOString(),
    profiles: {
      id: 'student8',
      username: 'upload_tester',
      display_name: 'Upload Tester',
      points: 720,
      reputation: 104
    }
  },

  // Network Security (5개)
  {
    id: 'study9',
    user_id: 'student9',
    type: 'study' as const,
    title: 'Wireshark로 TLS 트래픽 복호화하는 방법',
    content: 'HTTPS 트래픽을 캡처했는데 Wireshark에서 내용을 볼 수 없습니다. TLS 암호화된 패킷을 복호화해서 분석하려면 어떻게 해야 하나요? SSLKEYLOGFILE 환경변수 설정하면 된다고 들었는데 자세한 방법 알려주세요.',
    tags: ['wireshark', 'tls', 'network', 'packet-analysis'],
    status: 'solved',
    likes_count: 89,
    replies_count: 12,
    views_count: 634,
    created_at: new Date(Date.now() - 40 * 3600000).toISOString(),
    profiles: {
      id: 'student9',
      username: 'packet_analyzer',
      display_name: 'Packet Analyzer',
      points: 890,
      reputation: 156
    }
  },
  {
    id: 'study10',
    user_id: 'student10',
    type: 'study' as const,
    title: 'Nmap 스캔 결과 해석하는 방법',
    content: 'Nmap으로 포트 스캔을 했는데 결과를 어떻게 해석해야 할지 모르겠어요. open, filtered, closed의 차이점과 -sV, -sC 옵션의 의미를 알려주세요.',
    tags: ['nmap', 'network', 'port-scan', 'enumeration'],
    status: 'open',
    likes_count: 56,
    replies_count: 8,
    views_count: 423,
    created_at: new Date(Date.now() - 45 * 3600000).toISOString(),
    profiles: {
      id: 'student10',
      username: 'nmap_learner',
      display_name: 'Nmap Learner',
      points: 540,
      reputation: 73
    }
  },
  {
    id: 'study11',
    user_id: 'student11',
    type: 'study' as const,
    title: 'ARP Spoofing 공격 실습 질문',
    content: 'Ettercap으로 ARP Spoofing을 시도하고 있는데 트래픽이 캡처되지 않습니다. IP forwarding 설정은 했는데 뭐가 문제일까요? 가상 환경에서 실습 중입니다.',
    tags: ['arp-spoofing', 'network', 'mitm', 'ettercap'],
    status: 'open',
    likes_count: 43,
    replies_count: 6,
    views_count: 312,
    created_at: new Date(Date.now() - 50 * 3600000).toISOString(),
    profiles: {
      id: 'student11',
      username: 'mitm_student',
      display_name: 'MITM Student',
      points: 470,
      reputation: 61
    }
  },
  {
    id: 'study12',
    user_id: 'student12',
    type: 'study' as const,
    title: 'VPN 터널링 프로토콜 차이점 질문',
    content: 'OpenVPN, WireGuard, IPSec의 차이점이 궁금합니다. 보안 측면에서 어떤 프로토콜이 가장 안전한가요? 각각의 장단점을 알려주세요.',
    tags: ['vpn', 'network', 'tunneling', 'protocol'],
    status: 'solved',
    likes_count: 67,
    replies_count: 11,
    views_count: 589,
    created_at: new Date(Date.now() - 55 * 3600000).toISOString(),
    profiles: {
      id: 'student12',
      username: 'vpn_learner',
      display_name: 'VPN Learner',
      points: 780,
      reputation: 118
    }
  },
  {
    id: 'study13',
    user_id: 'student13',
    type: 'study' as const,
    title: 'DNS Tunneling 탐지하는 방법',
    content: 'DNS를 이용한 데이터 유출 기법을 공부하고 있습니다. DNS Tunneling을 어떻게 탐지하고 방어할 수 있나요? 실습 도구도 추천해주세요.',
    tags: ['dns', 'network', 'tunneling', 'detection'],
    status: 'open',
    likes_count: 51,
    replies_count: 7,
    views_count: 401,
    created_at: new Date(Date.now() - 60 * 3600000).toISOString(),
    profiles: {
      id: 'student13',
      username: 'dns_student',
      display_name: 'DNS Student',
      points: 610,
      reputation: 87
    }
  },

  // Reverse Engineering (4개)
  {
    id: 'study14',
    user_id: 'student14',
    type: 'study' as const,
    title: 'IDA Pro 기본 사용법 질문 - 함수 분석',
    content: 'IDA Pro를 처음 사용하는데 함수 호출 관계를 어떻게 확인하나요? Graph view와 Text view의 차이점도 알려주세요. 디컴파일러는 어떻게 사용하나요?',
    tags: ['ida-pro', 'reversing', 'disassembly', 'beginner'],
    status: 'open',
    likes_count: 62,
    replies_count: 9,
    views_count: 478,
    created_at: new Date(Date.now() - 65 * 3600000).toISOString(),
    profiles: {
      id: 'student14',
      username: 'ida_newbie',
      display_name: 'IDA Newbie',
      points: 520,
      reputation: 69
    }
  },
  {
    id: 'study15',
    user_id: 'student15',
    type: 'study' as const,
    title: 'Ghidra로 악성코드 분석 시작하기',
    content: 'Ghidra를 사용해서 악성코드를 분석하고 싶은데 어디서부터 시작해야 할지 모르겠어요. 기본적인 분석 순서와 주의할 점을 알려주세요.',
    tags: ['ghidra', 'reversing', 'malware', 'analysis'],
    status: 'solved',
    likes_count: 74,
    replies_count: 13,
    views_count: 612,
    created_at: new Date(Date.now() - 70 * 3600000).toISOString(),
    profiles: {
      id: 'student15',
      username: 'ghidra_learner',
      display_name: 'Ghidra Learner',
      points: 840,
      reputation: 142
    }
  },
  {
    id: 'study16',
    user_id: 'student16',
    type: 'study' as const,
    title: 'x64dbg 디버깅 중 안티디버깅 우회 방법',
    content: 'x64dbg로 프로그램을 디버깅하는데 안티디버깅 기법 때문에 막혔습니다. IsDebuggerPresent 체크를 우회하는 방법을 알려주세요.',
    tags: ['x64dbg', 'reversing', 'anti-debugging', 'bypass'],
    status: 'open',
    likes_count: 58,
    replies_count: 8,
    views_count: 445,
    created_at: new Date(Date.now() - 75 * 3600000).toISOString(),
    profiles: {
      id: 'student16',
      username: 'debugger_student',
      display_name: 'Debugger Student',
      points: 690,
      reputation: 95
    }
  },
  {
    id: 'study17',
    user_id: 'student17',
    type: 'study' as const,
    title: 'Crackme 문제 풀이 접근 방법',
    content: 'Crackme 문제를 풀어보려고 하는데 어떤 순서로 접근해야 하나요? 문자열 검색부터 시작하면 되나요? 초보자를 위한 쉬운 Crackme 사이트도 추천해주세요.',
    tags: ['crackme', 'reversing', 'practice', 'beginner'],
    status: 'solved',
    likes_count: 81,
    replies_count: 14,
    views_count: 723,
    created_at: new Date(Date.now() - 80 * 3600000).toISOString(),
    profiles: {
      id: 'student17',
      username: 'crackme_solver',
      display_name: 'Crackme Solver',
      points: 920,
      reputation: 167
    }
  },

  // Forensics (3개)
  {
    id: 'study18',
    user_id: 'student18',
    type: 'study' as const,
    title: 'Volatility로 메모리 덤프 분석하는 방법',
    content: 'Volatility 3를 사용해서 메모리 덤프를 분석하려고 합니다. 어떤 플러그인부터 실행해야 하나요? 프로세스 목록 확인하는 명령어를 알려주세요.',
    tags: ['volatility', 'forensics', 'memory', 'analysis'],
    status: 'open',
    likes_count: 69,
    replies_count: 10,
    views_count: 534,
    created_at: new Date(Date.now() - 85 * 3600000).toISOString(),
    profiles: {
      id: 'student18',
      username: 'forensics_student',
      display_name: 'Forensics Student',
      points: 760,
      reputation: 112
    }
  },
  {
    id: 'study19',
    user_id: 'student19',
    type: 'study' as const,
    title: 'Autopsy로 디스크 이미지 분석 질문',
    content: 'Autopsy를 사용해서 디스크 이미지를 분석하고 있는데 삭제된 파일을 복구하는 방법이 궁금합니다. Timeline 분석은 어떻게 하나요?',
    tags: ['autopsy', 'forensics', 'disk', 'recovery'],
    status: 'solved',
    likes_count: 55,
    replies_count: 8,
    views_count: 467,
    created_at: new Date(Date.now() - 90 * 3600000).toISOString(),
    profiles: {
      id: 'student19',
      username: 'disk_analyzer',
      display_name: 'Disk Analyzer',
      points: 680,
      reputation: 98
    }
  },
  {
    id: 'study20',
    user_id: 'student20',
    type: 'study' as const,
    title: 'Windows 이벤트 로그 분석 방법',
    content: 'Windows Event Viewer에서 보안 이벤트를 분석하고 싶습니다. 로그인 실패, 권한 상승 등의 이벤트 ID를 어떻게 찾나요? 유용한 도구도 추천해주세요.',
    tags: ['windows', 'forensics', 'event-log', 'analysis'],
    status: 'open',
    likes_count: 72,
    replies_count: 11,
    views_count: 598,
    created_at: new Date(Date.now() - 95 * 3600000).toISOString(),
    profiles: {
      id: 'student20',
      username: 'log_analyzer',
      display_name: 'Log Analyzer',
      points: 810,
      reputation: 128
    }
  },

  // Cryptography (2개)
  {
    id: 'study21',
    user_id: 'student21',
    type: 'study' as const,
    title: 'RSA 암호화 기초 질문 - 공개키와 개인키',
    content: 'RSA 암호화를 공부하고 있는데 공개키로 암호화하면 개인키로만 복호화할 수 있다는 게 어떻게 가능한가요? 수학적 원리가 궁금합니다.',
    tags: ['rsa', 'crypto', 'encryption', 'theory'],
    status: 'solved',
    likes_count: 64,
    replies_count: 9,
    views_count: 512,
    created_at: new Date(Date.now() - 100 * 3600000).toISOString(),
    profiles: {
      id: 'student21',
      username: 'crypto_student',
      display_name: 'Crypto Student',
      points: 590,
      reputation: 81
    }
  },
  {
    id: 'study22',
    user_id: 'student22',
    type: 'study' as const,
    title: 'CyberChef로 인코딩된 데이터 디코딩하기',
    content: 'Base64, Hex, URL 인코딩이 여러 번 적용된 데이터를 디코딩하고 싶습니다. CyberChef의 Magic 기능을 사용하면 자동으로 디코딩되나요?',
    tags: ['cyberchef', 'crypto', 'encoding', 'decoding'],
    status: 'open',
    likes_count: 47,
    replies_count: 6,
    views_count: 389,
    created_at: new Date(Date.now() - 105 * 3600000).toISOString(),
    profiles: {
      id: 'student22',
      username: 'decoder_student',
      display_name: 'Decoder Student',
      points: 510,
      reputation: 68
    }
  },

  // Cloud Security (2개)
  {
    id: 'study23',
    user_id: 'student23',
    type: 'study' as const,
    title: 'AWS IAM 권한 설정 베스트 프랙티스',
    content: 'AWS를 처음 사용하는데 IAM 권한을 어떻게 설정해야 안전한가요? 최소 권한 원칙을 적용하는 구체적인 방법을 알려주세요.',
    tags: ['aws', 'cloud', 'iam', 'security'],
    status: 'open',
    likes_count: 78,
    replies_count: 12,
    views_count: 645,
    created_at: new Date(Date.now() - 110 * 3600000).toISOString(),
    profiles: {
      id: 'student23',
      username: 'cloud_student',
      display_name: 'Cloud Student',
      points: 870,
      reputation: 145
    }
  },
  {
    id: 'study24',
    user_id: 'student24',
    type: 'study' as const,
    title: 'Kubernetes Pod Security 설정 질문',
    content: 'Kubernetes에서 Pod를 안전하게 배포하려면 어떤 보안 설정을 해야 하나요? SecurityContext와 PodSecurityPolicy의 차이점을 알려주세요.',
    tags: ['kubernetes', 'cloud', 'pod-security', 'container'],
    status: 'solved',
    likes_count: 85,
    replies_count: 13,
    views_count: 712,
    created_at: new Date(Date.now() - 115 * 3600000).toISOString(),
    profiles: {
      id: 'student24',
      username: 'k8s_learner',
      display_name: 'K8s Learner',
      points: 950,
      reputation: 178
    }
  },

  // Mobile Security (1개)
  {
    id: 'study25',
    user_id: 'student25',
    type: 'study' as const,
    title: 'Android APK 디컴파일하고 분석하는 방법',
    content: 'APKTool로 APK를 디컴파일했는데 smali 코드를 어떻게 읽어야 하나요? Java 코드로 변환하는 방법도 알려주세요. JADX 사용법도 궁금합니다.',
    tags: ['android', 'mobile', 'apk', 'decompile'],
    status: 'open',
    likes_count: 91,
    replies_count: 15,
    views_count: 789,
    created_at: new Date(Date.now() - 120 * 3600000).toISOString(),
    profiles: {
      id: 'student25',
      username: 'mobile_student',
      display_name: 'Mobile Student',
      points: 1020,
      reputation: 192
    }
  }
];